module.exports = __webpack_public_path__ + "img/bes-bireysel-emeklilik-sistemi.15e73765.png";